import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    UpgradeHelper, AdminToolPanelHelper, IAdminToolPanel, AdminToolHelper
} from '../../../helpers';

import { Spinner, SpinnerType, Button, ButtonType } from 'office-ui-fabric-react';
import { PanelHeader } from '../../admintool/panelheader';
import {SPINNER_LOADING_MESSAGE,PANEL_VALUE_BULKIMPORTTEXT} from '../../../constants';

interface IProps {
    adminToolState: any;
    panelName: string;
    panelTitle:string
    isDisplayed: boolean;
}
export class BulkImport extends React.Component<IProps, any> {
    componentDidMount() {
        AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, this.props.isDisplayed);
    }

    constructor(props: any) {
        super(props);
    }
    render() {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let displayed: boolean = AdminToolPanelHelper.IsPanelDisplayed(panel); 
        let isLoading = AdminToolPanelHelper.IsLoading(panel);
        let bulkTextAreaText = AdminToolPanelHelper.GetPanelValueFromState(panel, PANEL_VALUE_BULKIMPORTTEXT);
        let errorsList: string[] = AdminToolPanelHelper.GetErrorMessagesFromState(panel);
        let errors:any = errorsList && errorsList.map(result => <p>{result}</p>);

        return <div className="bulkimport admintool-panelcontainer">
            <PanelHeader panelTitle={this.props.panelTitle} enableToggle={true} isEnabled={false} adminToolState={this.props.adminToolState} panelName={this.props.panelName} />
            <div className="panel-content" style={!displayed ? { display: 'none' } : {}}>
                {isLoading && <Spinner className="loading-bulk" type={SpinnerType.normal} label={SPINNER_LOADING_MESSAGE} />}
                <textarea id="bulkimport" disabled={isLoading}
                    name="bulkimport" onChange={((event: any) => {
                        let value = event.target.value;
                        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
                        AdminToolPanelHelper.ClearPanelErrorMessages(panel)
                        AdminToolHelper.CheckGuidsTextArea(value, panel);
                        AdminToolPanelHelper.AddOrUpdatePanelValue(this.props.panelName, PANEL_VALUE_BULKIMPORTTEXT, value);
                    })
                    } />
                <br />
                <Button disabled={isLoading} icon="Copy" onClick={() => AdminToolHelper.CopyToClipboard("bulkimport")}>Copy To Clipboard</Button>
                <br />
                <Button icon="Add" buttonType={ButtonType.primary}
                    disabled={isLoading || errorsList.length > 0}
                    onClick={() => {
                        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
                        let valuesString: string = "" + AdminToolPanelHelper.GetPanelValueFromState(panel, "bulkimportText");
                        let values: string[] = [];
                        if (valuesString) {
                            values = valuesString.split(",");
                        }
                        AdminToolHelper.AddJourneysToProcessListState(values, panel, this.props.adminToolState.processList[this.props.adminToolState.tab]);
                    }}>Add to the list</Button>
                <br />
                {errors && errors.length > 0 && <div className="alert alert-danger" role="alert">
                    {errors}
                </div>}
            </div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/bulkimport.tsx